import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";

const getFeedbackUrl = () => {
  return `${window.location.origin}/feedback`;
};

const QRCodeModal = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);
  const feedbackUrl = getFeedbackUrl();

  const handleCopy = () => {
    navigator.clipboard.writeText(feedbackUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-[24px] shadow-2xl flex flex-col items-center overflow-hidden"
        style={{ width: 400, paddingBottom: 24, position: "relative" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header/Close Button */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-gray-400 hover:text-gray-600 transition"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        {/* QR Content */}
        <div className="flex flex-col items-center pt-12 ">
          <div className="mb-8">
            <QRCodeSVG value={feedbackUrl} size={220} />
          </div>

          <p className="text-[18px] text-[#111827] text-center font-medium mb-8">
            Scan the QR & share your feedback
          </p>
        </div>

        {/* Copy Button - Styled per Figma */}
        <button
          onClick={handleCopy}
          className="flex items-center justify-center gap-[8px] transition hover:opacity-90"
          style={{
            width: "352px",
            height: "50px",
            backgroundColor: "#FFF4E5",
            border: "1px solid #FFF4E5",
            borderRadius: "8px",
            padding: "10px 18px",
          }}
        >
          {/* Copy Icon */}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 12.9V17.1C16 18.2201 16 18.7802 15.782 19.208C15.5903 19.5843 15.2843 19.8903 14.908 20.082C14.4802 20.3 13.9201 20.3 12.8 20.3H7.2C6.0799 20.3 5.51984 20.3 5.09202 20.082C4.71569 19.8903 4.40973 19.5843 4.21799 19.208C4 18.7802 4 18.2201 4 17.1V11.5C4 10.3799 4 9.81984 4.21799 9.39202C4.40973 9.01569 4.71569 8.70973 5.09202 8.51799C5.51984 8.3 6.07989 8.3 7.2 8.3H11.4M16 12.9L11.4 8.3M16 12.9H12.5C11.94 12.9 11.66 12.9 11.446 12.791C11.2577 12.6951 11.1049 12.5423 11.009 12.354C10.9 12.14 10.9 11.86 10.9 11.3V7.8M11.4 8.3V4.8C11.4 4.24 11.4 3.96 11.509 3.746C11.6049 3.5577 11.7577 3.40493 11.946 3.30901C12.16 3.2 12.44 3.2 13 3.2H16.6C17.7201 3.2 18.2802 3.2 18.708 3.41799C19.0843 3.60973 19.3903 3.91569 19.582 4.29202C19.8 4.71984 19.8 5.27989 19.8 6.4V12.1C19.8 13.2201 19.8 13.7802 19.582 14.208C19.3903 14.5843 19.0843 14.8903 18.708 15.082C18.2802 15.3 17.7201 15.3 16.6 15.3H16"
              stroke="#374151"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-[16px] font-semibold text-[#374151]">
            {copied ? "Copied!" : "Copy"}
          </span>
        </button>
      </div>
    </div>
  );
};

export default QRCodeModal;